<template>
    <div class="view-inner">
        <div v-if="isLoading" class="loading-overlay">
            <div class="spinner-border text-light" role="status"></div>
            <p>Cargando...</p>
        </div>

        <!-- Page Header -->
        <div class="page-header">
            <h1 class="page-header-title"><i class="bi bi-truck"></i> Gestión de Costos Terrestre</h1>
            <div class="page-header-actions">
                <button class="btn-add" @click="abrirModalCostos()">
                    <i class="bi bi-plus-lg"></i> Agregar Costo
                </button>
            </div>
        </div>

        <!-- Filtros -->
        <div class="filter-card">
            <div class="row">
                <div class="col-md-3">
                    <label class="form-label">Destino</label>
                    <input type="text" class="form-control form-control-sm" v-model="filtros.destino" placeholder="Buscar por destino">
                </div>
                <div class="col-md-3">
                    <label class="form-label">Tipo de Envío</label>
                    <select class="form-select form-select-sm" v-model="filtros.tipoEnvio">
                        <option value="">Todos</option>
                        <option value="mercaderia">Mercadería</option>
                        <option value="documentos">Documento</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label class="form-label">&nbsp;</label>
                    <div class="filter-actions">
                        <button class="btn-filter" @click="filtrarCosto()"><i class="bi bi-search"></i> Buscar</button>
                        <button class="btn-clear" @click="limpiarFiltros"><i class="bi bi-x-circle"></i> Limpiar</button>
                        <button class="btn-export" @click="exportar"><i class="bi bi-file-earmark-excel"></i> Exportar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tabla de costos (estándar: ESTANDAR_LISTADOS.md) -->
        <div>
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>

                                <th>Departamento</th>
                                <th>Provincia</th>
                                <th>Distrito</th>
                                <th>Tipo de Envío</th>
                                <th class="text-end">Costo Envío (S/.)</th>
                                <th class="text-end">Lead Time</th>
                                <th class="text-end">Costo Visita (%)</th>
                                <th class="text-end">Falso Flete (%)</th>
                                <th class="col-acciones">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="costo in registros" :key="costo.id">

                                <td>{{ costo.departamento_nombre }}</td>
                                <td>{{ costo.provincia_nombre }}</td>
                                <td>{{ costo.distrito_nombre }}</td>
                                <td>{{ costo.tipo_envio ? costo.tipo_envio.charAt(0).toUpperCase() +
                                    costo.tipo_envio.slice(1).toLowerCase() : '' }}</td>
                                <td class="text-end celda-id">{{ costo.costo }}</td>
                                <td class="text-end celda-id">{{ costo.lead_time }}</td>
                                <td class="text-end celda-id">{{ costo.costo_visita }}</td>
                                <td class="text-end celda-id">{{ costo.falso_flete }}</td>
                                <td class="col-acciones">
                                    <button class="btn-icon btn-icon-edit" @click="editarCosto(costo)" title="Editar" aria-label="Editar">
                                        <i class="bi bi-pencil"></i>
                                    </button>
                                    <button class="btn-icon btn-icon-del" @click="eliminarCosto(costo)" title="Eliminar" aria-label="Eliminar">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            <tr v-if="!registros.length && !isLoading" class="empty-row">
                                <td colspan="9">No se encontraron costos</td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <!-- Paginado en la base de datos (25 por página) -->
            <PaginacionListado :pagina="pagina" :total-paginas="totalPaginas" :total="totalRegistros"
                :por-pagina="porPagina" :en-pagina="registros.length" :cargando="isLoading"
                etiqueta="costos" @cambiar="cambiarPagina" />
        </div>


        <!-- Modal para agregar/editar costos -->
        <div v-if="showModal" class="modal fade show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ modoEdicion ? 'Editar Costos' : 'Agregar Costos' }}
                        </h5>
                        <button type="button" class="btn-close" @click="cerrarModal"></button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="guardarCosto">
                            <h6 class="fw-bold text-secondary mt-3">Datos del Destino</h6>
                            <hr class="mt-1">
                            <div class="row">
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Departamento</label>
                                    <select class="form-control" @change="cargarProvincias()" v-model="departamento_id"
                                        required>
                                        <option value="">Seleccionar..</option>
                                        <option v-for="item in departamentos" :value="item.id" :key="item.id">{{
                                            item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Provincia</label>
                                    <select @change="cargarDistritos()" class="form-control" v-model="provincia_id"
                                        required>
                                        <option value="">Seleccionar..</option>
                                        <option v-for="item in provincias" :value="item.id" :key="item.id">{{
                                            item.nombre }}</option>
                                    </select>
                                </div>
                                <div class="mb-3 col-lg-4">
                                    <label class="form-label">Distrito</label>
                                    <select class="form-control" v-model="distrito_id" required>
                                        <option value="">Seleccionar..</option>
                                        <option v-for="item in distritos" :value="item.id" :key="item.id">{{ item.nombre
                                        }}</option>
                                    </select>
                                </div>
                            </div>

                            <h6 class="fw-bold text-secondary mt-5">Datos del Costo</h6>
                            <hr>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="tipoEnvio" class="form-label">Tipo de Envio <span
                                                class="text-danger">*</span></label>
                                        <select class="form-control" id="envio" v-model="form.tipo_envio"
                                            :class="{ 'is-invalid': errors.cargo }" required>
                                            <option value="">Seleccione..</option>
                                            <option value="mercaderia">MERCADERIA</option>
                                            <option value="documentos">DOCUMENTO</option>
                                        </select>
                                        <div v-if="errors.cargo" class="invalid-feedback">
                                            {{ errors.cargo }}
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="costo_envio" class="form-label">Costo de envío (S/.)<span
                                                class="text-danger">*</span></label>
                                        <input type="number" class="form-control" id="costo_envio" v-model="form.costo"
                                            :class="{ 'is-invalid': errors.costo }" required>
                                        <div v-if="errors.costo" class="invalid-feedback">
                                            {{ errors.costo }}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="lead_time" class="form-label">Lead time <span
                                                class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="lead_time" v-model="form.lead_time"
                                            :class="{ 'is-invalid': errors.lead_time }" required>
                                        <div v-if="errors.lead_time" class="invalid-feedback">
                                            {{ errors.lead_time }}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="costo_visita" class="form-label">Costo de visita (%) <span
                                                class="text-danger">*</span></label>
                                        <input type="number" class="form-control" id="costo_visita"
                                            v-model="form.costo_visita" :class="{ 'is-invalid': errors.costo_visita }"
                                            required>
                                        <div v-if="errors.costo_visita" class="invalid-feedback">
                                            {{ errors.costo_visita }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="mb-3">
                                        <label for="falso_flete" class="form-label">Falso flete (%) <span
                                                class="text-danger">*</span></label>
                                        <input type="number" class="form-control" id="faldo_flete"
                                            v-model="form.falso_flete" :class="{ 'is-invalid': errors.falso_flete }"
                                            required>
                                        <div v-if="errors.falso_flete" class="invalid-feedback">
                                            {{ errors.falso_flete }}
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="guardarCosto()">
                            {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>









    </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import PaginacionListado from '@/components/PaginacionListado.vue'
import paginacionServidor from '@/mixins/paginacionServidor'

export default {
    name: 'CostoModalidadTerrestrePage',
    components: { PaginacionListado },
    mixins: [paginacionServidor],
    data() {
        return {
            isLoading: false,
            endpointListado: '/gestion-costo-terrestre',
            showModal: false,
            modoEdicion: false,
            departamentos: [],
            provincias: [],
            distritos: [],
            filtros: {
                destino: '',
                tipoEnvio: '',
                tipoCosto: ''
            },
            form: {
                id: '',
                departamento: '',
                provincia: '',
                distrito: '',
                tipo_envio: '',
                tipo_costo: '',
                costo: '',
                lead_time: '',
                costo_visita: '',
                falso_flete: '',

            },
            departamento_id: '',
            provincia_id: '',
            distrito_id: '',
            errors: {}

        }
    },
    mounted() {
        this.cargarCostosTerrestres()
        this.cargarDepartamentos()
    },
    methods: {
        // Filtros que se envían al API (el filtrado, orden y paginado se hacen en la base)
        parametrosFiltro() {
            return { destino: this.filtros.destino, tipo_envio: this.filtros.tipoEnvio }
        },

        // Recarga la página actual (con los filtros activos) después de crear, editar o eliminar
        cargarCostosTerrestres() {
            return this.cargarListado()
        },

        // Exporta todos los registros filtrados (no solo la página visible)
        async exportar() {
            this.isLoading = true
            let todos = []
            try {
                todos = await this.todosLosRegistros()
            } catch (error) {
                Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo generar el Excel. Intenta nuevamente.' })
                return
            } finally {
                this.isLoading = false
            }
            const num = v => (v === null || v === undefined || v === '' || isNaN(v) ? v : Number(v))
            const filas = [
                ['Departamento', 'Provincia', 'Distrito', 'Tipo de Envío', 'Costo Envío (S/.)', 'Lead Time', 'Costo Visita (%)', 'Falso Flete (%)'],
                ...todos.map(costo => [
                    costo.departamento_nombre,
                    costo.provincia_nombre,
                    costo.distrito_nombre,
                    costo.tipo_envio ? costo.tipo_envio.charAt(0).toUpperCase() + costo.tipo_envio.slice(1).toLowerCase() : '',
                    num(costo.costo),
                    costo.lead_time,
                    num(costo.costo_visita),
                    num(costo.falso_flete),
                ]),
            ]
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(filas), 'Hoja1')
            XLSX.writeFile(wb, 'reporte.xlsx')
        },

        async cargarDepartamentos() {
            try {
                const response = await axios.get('/departamentos')  //
                this.departamentos = response.data.data || response.data
            } catch (error) {
                console.error('Error al cargar departamentos:', error)
            }
        },
        async cargarProvincias() {
            try {
                this.distritos = []
                const response = await axios.get('/provinciasByDepartamentos/' + this.departamento_id)
                this.provincias = response.data
            } catch (error) {
                console.error('Error al cargar provincias', error)
            }
        },
        async cargarDistritos() {
            try {
                const response = await axios.get('/distritosByProvincias/' + this.provincia_id)
                this.distritos = response.data
            } catch (error) {
                console.error('Error al cargar distritos', error)
            }
        },

        limpiarFiltros() {
            this.filtros = {
                destino: '',
                tipoEnvio: '',
                tipoCosto: ''
            }
            this.aplicarFiltros()
        },

        filtrarCosto() {
            this.aplicarFiltros()
        },

        abrirModalCostos(costo = null) {
            this.modoEdicion = !!costo
            this.errors = {}

            if (costo) {
                this.form = { ...costo }
            } else {
                this.form = {
                    id_costo: null,
                    departamento: '',
                    provincia: '',
                    distrito: '',
                    contacto: '',
                    tipo_envio: '',
                    tipo_costo: '',
                    costo: '',
                    lead_time: '',
                    costo_visita: '',
                    falso_flete: ''
                }
            }
            if (this.modoEdicion) {
                this.departamento_id = costo.distrito.provincia.departamento.id;
                this.cargarProvincias();
                this.provincia_id = costo.distrito.provincia.id;
                this.cargarDistritos();
                this.distrito_id = costo.distrito.id;
            }

            this.showModal = true
        },

        editarCosto(costo) {
            this.abrirModalCostos(costo)
        },

        cerrarModal() {
            this.showModal = false
            this.modoEdicion = false
            this.errors = {}
        },

        async guardarCosto() {
            try {
                this.errors = {}

                // Validaciones básicas
                if (!this.departamento_id) {
                    this.errors.departamento = 'El departamento es requerido'
                }
                if (!this.provincia_id) {
                    this.errors.provincia = 'La provincia es requerida'
                }
                if (!this.distrito_id) {
                    this.errors.distrito = 'El distrito es requerido'
                }
                if (!this.form.tipo_envio.trim()) {
                    this.errors.tipo_envio = 'El tipo de envío es requerido'
                }
                if (!this.form.costo) {
                    this.errors.costo = 'El costo envio es requerido'
                }
                if (!this.form.lead_time.trim()) {
                    this.errors.lead_time = 'El lead time es requerido'
                }
                if (!this.form.costo_visita) {
                    this.errors.costo_visita = 'El costo de visita es requerido'
                }
                if (!this.form.falso_flete) {
                    this.errors.falso_flete = 'El falso flete es requerido'
                }
                if (Object.keys(this.errors).length > 0) {
                    return
                }

                this.form.ubigeo = this.distritos.find(item => item.id == this.distrito_id).ubigeo;

                let response
                if (this.modoEdicion) {
                    response = await axios.put(`/gestion-costo-terrestre/${this.form.id}`, this.form)
                } else {
                    response = await axios.post('/gestion-costo-terrestre', this.form)
                }

                if (response.data) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: `Costo ${this.modoEdicion ? 'actualizado' : 'registrado'} correctamente`
                    })

                    this.cerrarModal()
                    this.cargarCostosTerrestres()
                }
            } catch (error) {
                console.error('Error al guardar costo de envio:', error)
                if (error.response && error.response.data && error.response.data.errors) {
                    this.errors = error.response.data.errors
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo guardar la información del costo de envio'
                    })
                }
            }
        },

        async eliminarCosto(costo) {
            try {
                const result = await Swal.fire({
                    title: '¿Estás seguro?',
                    text: `Se eliminará el costo asignado a ${costo.departamento_nombre} - ${costo.provincia_nombre} - ${costo.distrito_nombre}`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sí, eliminar',
                    cancelButtonText: 'Cancelar'
                })

                if (result.isConfirmed) {
                    await axios.delete(`/gestion-costo-terrestre/${costo.id}`)

                    Swal.fire({
                        icon: 'success',
                        title: 'Eliminado',
                        text: 'El costo de envio ha sido eliminado correctamente'
                    })
                    this.cargarCostosTerrestres()
                }
            } catch (error) {
                console.error('Error al eliminar costo de envío:', error)
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo eliminar el costo de envio'
                })
            }
        }
    }
}

</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    color: white;
}

.modal.show {
    display: block !important;
}

.badge {
    font-size: 0.8em;
}

.text-danger {
    color: #dc3545 !important;
}

.is-invalid {
    border-color: #dc3545;
}

.invalid-feedback {
    display: block;
}
</style>